
    <h3 class="mat-dialog-title">
      <span>{{data.adUnitName}}</span>
    </h3>
    <mat-dialog-content>
      <textarea #foo
                title="Pixel tag"
                class="mat-input-element textarea-note w-100 mb-1"
                [(ngModel)]="data.pixelTag"
                style="height: 200px;"></textarea>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="primary" [ngxClipboard]="foo" (cbOnSuccess)="onCopyToClipboard()" class="iconed  mb-3 mb-sm-0">
        <i class="fas fa-clipboard"></i>
        <span>Copy to clipboard</span>
      </button>
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
  